import React, { useState } from 'react';
import {
  Box,
  Button,
  Container,
  Grid,
  TextField,
  Typography,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
} from '@mui/material';

const Section = ({ title, children }) => (
  <Box mt={5}>
    <Typography variant="h6" mb={2} fontWeight="bold">
      {title}
    </Typography>
    {children}
  </Box>
);

const Estamp = () => {
  const [formData, setFormData] = useState({
    applicationDate: '',
    title: '',
    email: '',
    stampDutyAmount: '',
    considerationAmount: '',
            phone: '',

    article: '',
      description: '',
    firstParty: { name: '', address: '', pan: '',  },
    secondParty: { name: '', address: '', pan: '',},
    stampDutyPaidBy: '',
    responsibleParty: '',
  });

  const [openDialog, setOpenDialog] = useState(false);
  const [guidelinesAccepted, setGuidelinesAccepted] = useState(false);

  const handleChange = (e, section = null) => {
    const { name, value } = e.target;
    if (section) {
      setFormData((prev) => ({
        ...prev,
        [section]: {
          ...prev[section],
          [name]: value,
        },
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('https://charethribs.com/api/estamp', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.success) {
        setOpenDialog(true);
        setTimeout(() => {
          setOpenDialog(false);
          setFormData({
            applicationDate: '',
            title: '',
            email: '',
            phone: '',
  description: '',
            stampDutyAmount: '',
            considerationAmount: '',
            article: '',
            firstParty: { name: '', address: '', pan: '',  },
            secondParty: { name: '', address: '', pan: '',  },
            stampDutyPaidBy: '',
            responsibleParty: '',
          });
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 3000);
      } else {
        alert('Failed to submit form');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Something went wrong.');
    }
  };

  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      {!guidelinesAccepted ? (
   <Paper elevation={1} sx={{ p: 3, bgcolor: '#f5f5f5' }}>
    <Typography variant="h6" fontWeight="bold" gutterBottom>
      ಅರ್ಜಿ ಭರ್ತಿ ಮಾಡಲು ಸೂಚನೆಗಳು / Guidelines for Filling the Application
    </Typography>

    <Typography variant="body2" component="div" sx={{ lineHeight: 2 }}>
      <ol style={{ paddingLeft: '1.2rem' }}>
        <li>
          ಅರ್ಜಿಯಲ್ಲಿ ಕೇಳಿರುವ ಎಲ್ಲಾ ಮಾಹಿತಿಯನ್ನು ಪರಿಶೀಲಿಸಿ ಭರ್ತಿ ಮಾಡುವುದು.  
          <br />
          <i>Fill up the details after going through all the information specified in the application form.</i>
        </li>
        <li>
          ಅವಶ್ಯಕತೆ ಇರುವಲ್ಲಿ ಭರ್ತಿ ಮಾಡುವುದು.
          <br />
          <i>Wherever required please fill in.</i>
        </li>
        <li>
          <b>Issue of E-Stamping Certificate / ಇ-ಸ್ಟ್ಯಾಂಪಿಂಗ್ ಪ್ರಮಾಣಪತ್ರದ ವಿತರಣೆ</b>
          <ul style={{ paddingLeft: '1rem' }}>
            <li>
              ನಗದು/ಆನ್‌ಲೈನ್ ಪಾವತಿಯ ನಂತರವೇ ಇ-ಸ್ಟ್ಯಾಂಪಿಂಗ್ ಪ್ರಮಾಣಪತ್ರವನ್ನು ನೀಡಲಾಗುತ್ತದೆ.
              <br />
              <i>The issue of the E-Stamping Certificate will be issued only after cash/online payment.</i>
            </li>
            <li>
              ಇ-ಸ್ಟಾಂಪಿಂಗ್ ಸರ್ಟಿಫಿಕೇಟ್ ಡಿಡಿ/ಪೇ ಆರ್ಡರ್ ನಗದಾದ ನಂತರವೇ ನೀಡಲಾಗುವುದು. ಡಿಡಿ/ಪೇ-ಆರ್ಡರ್ "CHARETHRI BUSINESS SOLUTIONS LLP". ರವರ ಹೆಸರಿಗೆ ಬರೆಯುವುದು/ತರುವುದು.
              <br />
              <i>
                DD/Payorder should be drawn in favour of "CHARETHRI BUSINESS SOLUTIONS LLP". The E-Stamp certificate will be issued only after realization of DD/Pay order.
              </i>
            </li>
          </ul>
        </li>
        <li>
          ಹಣಮರುಪಾವತಿ ಪರವಾಗಿ ಸಂಬಂಧಪಟ್ಟ ಜಿಲ್ಲಾ ನೋಂದಣಾಧಿಕಾರಿಗಳನ್ನು ಸಂಪರ್ಕಿಸಬೇಕು.
          <br />
          <i>For cancellation of an e-stamp, the client has to go to the District Registrar's Office and obtain refund.</i>
        </li>
        <li>
          ಹಣ ಮರುಪಾವತಿ ಪರವಾಗಿ ಇನ್ನೊಬ್ಬ ವ್ಯಕ್ತಿ ಇ-ಸ್ಟಾಂಪಿಂಗ್ ಸರ್ಟಿಫಿಕೇಟ್ ಪಡೆಯಲು ಹಣ ಪಾವತಿದಾರರು ನೀಡಿದ ಸೂಕ್ತ ಪರವಾನಗಿ ಪತ್ರ ಹಾಜರುಪಡಿಸಬೇಕು.
          <br />
          <i>If any other person is coming on behalf of the client, then he has to come with the authorization letter for collecting the e-stamp certificate.</i>
        </li>
        <li>
          "ಚರೆತ್ರಿ ಬಿಸಿನೆಸ್ಸೊಲ್ಯೂಷನ್ಸ್ ಎಲ್ ಎಲ್ ಪಿ". ಇ-ಸ್ಮಾಂಪಿಂಗ್‌ಗೆ ಪಾವತಿಸಬೇಕಾದ ಶುಲ್ಕವನ್ನು ನಿರ್ಧರಿಸುವ ಅಧಿಕಾರ ಹೊಂದಿರುವುದಿಲ್ಲ. ಪಕ್ಷಗಾರರು ಮುದ್ರಾಂಕ ಶುಲ್ಕದ ಮೊತ್ತವನ್ನು ತಾವೇ ನಿರ್ಧರಿಸುವುದು.
          <br />
          <i>"CHARETHRI BUSINESS SOLUTIONS LLP" is not responsible for fixing the stamp duty amount and it has to be calculated/confirmed by the client.</i>
        </li>
        <li>
          ಹಣ ಪಾವತಿಸಿಕೊಂಡು ಇ-ಸ್ಟಾಂಪಿಂಗ್ ಮೂಲಕ ಒಮ್ಮೆ ನೀಡಲಾದ ಸರ್ಟಿಫಿಕೇಟನ್ನು ರದ್ದುಪಡಿಸಲಾಗುವುದಿಲ್ಲ.
          <br />
          <i>As per the e-stamping procedure, once the certificate is issued it cannot be cancelled </i>
        </li>
        <li>
          ಕರ್ನಾಟಕ ಸರ್ಕಾರದ ಆದೇಶದಂತೆ ಸೇವಾ ಶುಲ್ಕ ಅನ್ವಯಿಸುತ್ತದೆ.
          <br />
          <i>Service charges applicable as per Government order. Client can obtain receipt towards service charges from the counter.</i>
        </li>
      </ol>

      <Box mt={3}>
        <Typography fontWeight="bold">Note:</Typography>
        <ul>
          <li>
            Once the Stamp Certificate has been generated, payment cannot be cancelled or refunded. For cancellation, you need to get in touch with the complaint authority at the stamp office by the State Government.
          </li>
          <li>
            The correctness of article type and stamp duty amount cannot be confirmed at the e-Stamping counter.
          </li>
          <li>
            Cancellation charges are applicable as levied by the State Government.
          </li>
          <li>
            Stamp Duty Amount should be rounded off to the nearest Rupee.
          </li>
        </ul>
      </Box>

      <Box mt={2}>
        <Typography fontWeight="bold">ಸೂಚನೆ:</Typography>
        <Typography>
          ಹಣ ಪಾವತಿಸಿಕೊಂಡು ಇ-ಸ್ಟಾಂಪಿಂಗ್ ಮೂಲಕ ಒಮ್ಮೆ ನೀಡಲಾದ ಸರ್ಟಿಫಿಕೇಟ್‌ನ್ನು ರದ್ದು ಪಡಿಸಲಾಗುವುದಿಲ್ಲ. ಹಣ ಪಾವತಿಗೆ ಸಂಬಂಧಪಟ್ಟ ಜಿಲ್ಲಾ ನೋಂದಣಾಧಿಕಾರಿಗಳನ್ನು ಸಂಪರ್ಕಿಸಬೇಕು.
        </Typography>
      </Box>
    </Typography>

    <Box mt={4} textAlign="center">
      <Button
        variant="contained"
        color="primary"
        size="large"
        onClick={() => setGuidelinesAccepted(true)}
      >
        I Agree
      </Button>
    </Box>
  </Paper>
      ) : (
      <form onSubmit={handleSubmit}>
  <Grid container spacing={4}>
    <Grid item xs={12}>
      <Paper elevation={1} sx={{ p: { xs: 2, sm: 4 }, backgroundColor: '#fff' }}>
        <Typography variant="h4" textAlign="center" fontWeight="bold" gutterBottom>
          E-Stamp Paper (Non-Judicial)
        </Typography>

        <Box bgcolor="#e3f2fd" p={2} mb={4} borderRadius={1}>
          <Typography variant="body2">
            <strong className='text-center items-center flex justify-center underline text-lg'>To your doorstep</strong>
            <br />
            
             If you need us to draft or if the content is ready, <span style={{ color: '#1976d2', fontWeight: 'bold' }}>info@charethribs.in   </span>                                                                 
      directly. We have a fleet of lawyers who can draft and an experienced staff who can send for your approval and print the approved document on e-stamp paper. Once printed, the document will be sent to your doorstep by Denzo or any similar service; the customers will bear delivery charges.
          </Typography>
        </Box>

        {/* Section 1: Application Info */}
        <Section title="Application Information">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Application Date"
                name="applicationDate"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={formData.applicationDate}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Stamp Duty Amount"
                name="stampDutyAmount"
                value={formData.stampDutyAmount}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Consideration/Advance Amount"
                name="considerationAmount"
                value={formData.considerationAmount}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Article / Purpose "
                name="article"
                value={formData.article}
                onChange={handleChange}
                required
              />
            </Grid>
         <Grid item xs={12} >
                      <TextField
                        fullWidth
                        label="Description"
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                          multiline
                rows={2}
                        required
                      />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Email ID"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </Grid>
          <Grid item xs={12} sm={6}>
  <TextField
    fullWidth
    label="Phone Number"
    name="phone"
    value={formData.phone}
    onChange={handleChange}
                required

  />
</Grid>

          </Grid>
        </Section>

        {/* Section 2: First Party */}
        <Section title="First Party">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Name"
                name="name"
                value={formData.firstParty.name}
                onChange={(e) => handleChange(e, 'firstParty')}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="PAN Number"
                name="pan"
                value={formData.firstParty.pan}
                onChange={(e) => handleChange(e, 'firstParty')}
              />
            </Grid>
     
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Address"
                name="address"
                value={formData.firstParty.address}
                onChange={(e) => handleChange(e, 'firstParty')}
                multiline
                rows={2}
                required
              />
            </Grid>
          </Grid>
        </Section>

        {/* Section 3: Second Party */}
        <Section title="Second Party">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Name"
                name="name"
                value={formData.secondParty.name}
                onChange={(e) => handleChange(e, 'secondParty')}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="PAN Number"
                name="pan"
                value={formData.secondParty.pan}
                onChange={(e) => handleChange(e, 'secondParty')}
              />
            </Grid>
       
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Address"
                name="address"
                value={formData.secondParty.address}
                onChange={(e) => handleChange(e, 'secondParty')}
                multiline
                rows={2}
                required
              />
            </Grid>
          </Grid>
        </Section>

        {/* Section 4: Stamp Duty Info */}
        <Section title="Stamp Duty Info">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Stamp Duty Paid By"
                name="stampDutyPaidBy"
                value={formData.stampDutyPaidBy}
                onChange={handleChange}
              />
            </Grid>
<Grid item xs={12}>
  <TextField
    select
    fullWidth
    label=" Select Party"
    name="responsibleParty"
    value={formData.responsibleParty}
    onChange={handleChange}
    SelectProps={{ native: true }}
    sx={{ minWidth: '300px' }} // Force a minimum size
  >
    <option value=""> </option>
    <option value="First Party">First Party</option>
    <option value="Second Party">Second Party</option>
  </TextField>
</Grid>


          </Grid>
        </Section>



        <Box mt={4} textAlign="right">
          <Button variant="contained" size="large" color="primary" type="submit">
            Submit Form
          </Button>
        </Box>
      </Paper>
    </Grid>
  </Grid>
</form>

      )}

      {/* Thank You Dialog */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Thank You!</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Your E-Stamp form has been successfully submitted.
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </Container>
  );
};

export default Estamp;
